import { render, staticRenderFns } from "./AggiungiModificaCliente.vue?vue&type=template&id=1459fd6e&"
import script from "./AggiungiModificaCliente.vue?vue&type=script&lang=js&"
export * from "./AggiungiModificaCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports